import styled from 'styled-components/macro'

export const ContentS = styled.div`
  display: flex;
  flex-direction: column;

`
